// =========================================================
// frontend/js/widgets.js - V7.0 (Sync & Live-Preview)
// =========================================================

window.renderWidgetsPage = function() {
    const u = window.currentUser;
    const cid = u?.companyId;
    const domain = "https://presenzo.de"; 
    const liveUrl = "https://presenzo-2bef1.web.app"; // Deine Firebase-URL

    console.log("🛠️ WIDGET-DEBUG: CID =", cid);

    // Iframe-Codes für die Kopier-Felder
    const iframeSquare = `<iframe src="${liveUrl}/public-widget.html?cid=${cid}" width="400" height="400" frameborder="0" style="border-radius:2.3rem;"></iframe>`;
    const iframeRect = `<iframe src="${liveUrl}/public-widget.html?cid=${cid}" width="400" height="250" frameborder="0" style="border-radius:2.3rem;"></iframe>`;

    // 🚀 LIVE-VORSCHAU (Nutzt jetzt onSnapshot für Echtzeit-Updates im Dashboard)
    // Wir speichern den Unsubscribe-Befehl, um Speicherlecks zu vermeiden
    if (window.widgetPreviewUnsub) window.widgetPreviewUnsub();

    setTimeout(() => {
        const valueSq = document.getElementById('paper-widget-co2-value-sq');
        const treeSq = document.getElementById('paper-widget-trees-value-sq');
        const valueRect = document.getElementById('paper-widget-co2-value-rect');
        const treeRect = document.getElementById('paper-widget-trees-value-rect');

        if (!cid || !valueSq) return;

        window.widgetPreviewUnsub = db.collection('companies').doc(cid).onSnapshot(doc => {
            if (doc.exists) {
                const data = doc.data();
                const totalNetto = parseFloat(data.stats?.totalCO2 || 0);
                // Baum-Faktor 12.5 (Standard für Buche/Mischwald pro Jahr)
                const trees = (totalNetto / 12.5).toFixed(1);

                // Update Quadratisch
                valueSq.innerHTML = `${totalNetto.toFixed(1)} <span class="text-3xl">kg</span>`;
                treeSq.innerText = `entspricht ${trees} Bäumen`;
                valueSq.classList.remove('animate-pulse');

                // Update Rechteckig
                valueRect.innerHTML = `${totalNetto.toFixed(1)} <span class="text-2xl">kg</span>`;
                treeRect.innerText = `${trees} Bäume`;
                valueRect.classList.remove('animate-pulse');
            }
        });
    }, 100);

    return `
        <div class="p-8 lg:p-12 animate-fadeIn max-w-[1200px] mx-auto pb-32">
            <div class="mb-12 text-center">
                <div class="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-50 border border-emerald-100 text-emerald-800 text-[10px] font-black uppercase tracking-widest mb-6 shadow-sm">
                    <i data-lucide="code" class="w-3 h-3"></i> Widgets
                </div>
                <h2 class="text-4xl lg:text-5xl font-black text-slate-800 tracking-tighter mb-4">Marketing Widgets</h2>
                <p class="text-slate-500 font-medium text-sm max-w-xl mx-auto leading-relaxed">
                    Präsentiere deinen Impact auf deiner Website. Die Daten werden in Echtzeit synchronisiert.
                </p>
            </div>

            <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
                
                <div class="space-y-12">
                    <div>
                        <p class="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-6 px-2">Format: Quadratisch (400x400)</p>
                        <div class="p-1 border border-slate-200 rounded-[2.5rem] bg-white shadow-xl w-full max-w-[400px] aspect-square flex mx-auto">
                            <div class="w-full h-full rounded-[2.3rem] text-center overflow-hidden relative flex flex-col items-center justify-center p-8 text-emerald-800" style="background-color: #fcfcf9; background-image: url('https://www.transparenttextures.com/patterns/cream-paper.png'); border: 1px solid #e1e0d7;">
                                <div class="w-16 h-16 border-2 border-emerald-800 rounded-full flex items-center justify-center mb-6 shrink-0">
                                    <i data-lucide="leaf" class="w-7 h-7 text-emerald-800 transform -translate-x-0.5"></i>
                                </div>
                                <h4 class="font-black text-xl mb-1 tracking-tighter">Nachhaltigkeits-Impact</h4>
                                <p class="text-[9px] font-bold uppercase tracking-widest mb-4 italic">(${u.companyName || 'Firma'})</p>
                                <div id="paper-widget-co2-value-sq" class="text-6xl font-black tracking-tighter mb-1 animate-pulse flex items-baseline justify-center gap-2">
                                    <span class="text-2xl text-slate-300">...</span>
                                </div>
                                <p class="text-[9px] font-bold uppercase tracking-widest mb-4">CO₂-Ersparnis (Netto)</p>
                                <div class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-emerald-800/20 bg-emerald-800/5">
                                    <i data-lucide="tree-pine" class="w-3.5 h-3.5 text-emerald-800"></i>
                                    <span id="paper-widget-trees-value-sq" class="text-[9px] font-black uppercase tracking-widest">Lädt...</span>
                                </div>
                                <div class="absolute bottom-6 w-full px-8 flex justify-between items-center text-[8px] font-bold uppercase tracking-widest">
                                    <div><span class="w-2 h-2 inline-block rounded-full bg-emerald-600 animate-pulse mr-1"></span> LIVE</div>
                                    <div>BY <a href="${domain}" target="_blank" class="font-black hover:underline">PRESENZO</a></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <p class="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-6 px-2">Format: Kompakt (400x250)</p>
                        <div class="p-1 border border-slate-200 rounded-[2.5rem] bg-white shadow-xl w-full max-w-[400px] h-[250px] flex mx-auto">
                            <div class="w-full h-full rounded-[2.3rem] text-center overflow-hidden relative flex flex-col items-center justify-center p-6 text-emerald-800" style="background-color: #fcfcf9; background-image: url('https://www.transparenttextures.com/patterns/cream-paper.png'); border: 1px solid #e1e0d7;">
                                <div class="flex items-center gap-4 mb-4">
                                    <div class="w-12 h-12 border-2 border-emerald-800 rounded-full flex items-center justify-center shrink-0">
                                        <i data-lucide="leaf" class="w-5 h-5 text-emerald-800 transform -translate-x-0.5"></i>
                                    </div>
                                    <div class="text-left">
                                        <h4 class="font-black text-lg tracking-tighter leading-none">Impact</h4>
                                        <p class="text-[8px] font-bold uppercase tracking-widest italic opacity-60">${u.companyName || 'Firma'}</p>
                                    </div>
                                </div>
                                <div id="paper-widget-co2-value-rect" class="text-5xl font-black tracking-tighter mb-1 animate-pulse">
                                    <span class="text-xl text-slate-300">...</span>
                                </div>
                                <div class="flex items-center gap-3">
                                    <p class="text-[8px] font-bold uppercase tracking-widest">CO₂ gespart</p>
                                    <div class="w-1 h-1 rounded-full bg-emerald-800/30"></div>
                                    <p id="paper-widget-trees-value-rect" class="text-[8px] font-black uppercase tracking-widest">...</p>
                                </div>
                                <div class="absolute bottom-4 w-full px-8 flex justify-between items-center text-[7px] font-bold uppercase tracking-widest">
                                    <div class="opacity-40">Live Data Sync</div>
                                    <div>BY <a href="${domain}" target="_blank" class="font-black hover:underline">PRESENZO</a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="space-y-6">
                    <div class="bg-white rounded-[2.5rem] p-8 border border-slate-200 shadow-sm">
                        <h3 class="text-xl font-black text-slate-800 mb-6 tracking-tight">Code kopieren</h3>
                        
                        <div class="space-y-8">
                            <div>
                                <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-3 block">Einbettung Quadratisch</label>
                                <div class="relative bg-slate-900 rounded-2xl p-4 mb-3">
                                    <code id="code-sq" class="text-[10px] font-mono text-emerald-400 block break-all leading-relaxed">${iframeSquare.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</code>
                                </div>
                                <button onclick="window.copyAnyCode('code-sq')" class="w-full bg-slate-100 text-slate-700 py-3 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-slate-900 hover:text-white transition-all flex items-center justify-center gap-2">
                                    <i data-lucide="copy" class="w-3 h-3"></i> Code kopieren
                                </button>
                            </div>

                            <div>
                                <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-3 block">Einbettung Kompakt</label>
                                <div class="relative bg-slate-900 rounded-2xl p-4 mb-3">
                                    <code id="code-rect" class="text-[10px] font-mono text-emerald-400 block break-all leading-relaxed">${iframeRect.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</code>
                                </div>
                                <button onclick="window.copyAnyCode('code-rect')" class="w-full bg-slate-100 text-slate-700 py-3 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-slate-900 hover:text-white transition-all flex items-center justify-center gap-2">
                                    <i data-lucide="copy" class="w-3 h-3"></i> Code kopieren
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    `;
};